import React, { useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import ReactToPrint from "react-to-print";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import '../invoice.css';
import PaymentOutInvoicePage from "./PaymentOutInvoicePage";

const PaymentOutPdfDialog = ({}) => {
    const pdfRef = useRef(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isNew = queryParams.get('new');
    const auth = queryParams.get('auth');
    const [theme, setTheme] = useState("");
    const [isClickToGeneratePDF, setIsClickToGeneratePDF] = useState(false);
    
    const toggleTheme = (themeName) => {
        document.documentElement.className = themeName;
        setTheme(themeName);
    };

   

    

    const closeBtn = () => {
        console.log(isNew);
        if(isNew){
            window.location.href = global.webUrl + "business/manage-purchase-payment-out/";
        }else{
            window.open('', '_self').close();
        }
    }

   
   
    return (
        <Dialog minWidth={'60%'} height={'95%'} title={'Preview'} onClose={() => {
            closeBtn();
        }}>
            <div style={{ display: "flex", flexDirection: "row", gap: "20px", marginBottom: '40px' }}>
                <p><b>Theme color</b></p>
                <Button style={{ backgroundColor: '#9f9fdf', color: 'white' }} onClick={() => {
                    toggleTheme("")
                }}>
                    {theme == '' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#222222', color: 'white' }} onClick={() => {
                    toggleTheme("theme1")
                }}>
                    {theme == 'theme1' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#007BFF', color: 'white' }} onClick={() => {
                    toggleTheme("theme2")
                }}>
                    {theme == 'theme2' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#28A745', color: 'white' }} onClick={() => {
                    toggleTheme("theme3")
                }}>
                    {theme == 'theme3' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#B6B6B4', color: 'white' }} onClick={() => {
                    toggleTheme("theme4")
                }}>
                    {theme == 'theme4' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#4863A0', color: 'white' }} onClick={() => {
                    toggleTheme("theme5")
                }}>
                    {theme == 'theme5' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#0020C2', color: 'white' }} onClick={() => {
                    toggleTheme("theme6")
                }}>
                    {theme == 'theme6' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#6698FF', color: 'white' }} onClick={() => {
                    toggleTheme("theme7")
                }}>
                    {theme == 'theme7' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#7E587E', color: 'white' }} onClick={() => {
                    toggleTheme("theme8")
                }}>
                    {theme == 'theme8' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#728C00', color: 'white' }} onClick={() => {
                    toggleTheme("theme9")
                }}>
                    {theme == 'theme9' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
                <Button style={{ backgroundColor: '#E77471', color: 'white' }} onClick={() => {
                    toggleTheme("theme10")
                }}>
                    {theme == 'theme10' ? <i className="fa fa-check mr-5"></i> : ''}
                </Button>
            </div>
            {
                auth && <PaymentOutInvoicePage auth={auth} pdfRef={pdfRef} isClickToGeneratePDF={isClickToGeneratePDF} />
            }

            <DialogActionsBar>
                <Button class="btn btn-alt-secondary" style={{ textTransform: 'capitalize' }} onClick={() => {
                    setIsClickToGeneratePDF(true);
                }}>
                    <i className="fa fa-file-pdf-o"></i> Download PDF
                </Button>
                <ReactToPrint
                    trigger={() => (
                        <button type="button" className="btn btn-alt-secondary">
                            <i className="fa fa-print"></i> View Print
                        </button>
                    )}
                    pageStyle={`body { margin: 10px;}`}
                    content={() => pdfRef.current}
                />
                <Button class="btn btn-alt-secondary" style={{ textTransform: 'capitalize' }} onClick={() => {
                    closeBtn();
                }}>
                    <i className="fa fa-times"></i> Close
                </Button>
            </DialogActionsBar>
        </Dialog>
    )
}
export default PaymentOutPdfDialog;